/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../environments/environment';
import { AppService } from './app.service';
import { Observable } from 'rxjs';
import * as printJS from 'print-js'

@Injectable({
  providedIn: 'root'
})
export class NspRequestService {

  constructor(private httpClient: HttpClient, private app: AppService) { }

  addNspRequest(nspRequest: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.put(this.app.getUrl() + environment.addNspRequestUrl, nspRequest,
      { responseType: 'blob', headers }) as Observable<any>;
  }

  addNspFamilyRequest(nspFamilyRequest: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.put(this.app.getUrl() + environment.addNspFamilyRequestUrl, nspFamilyRequest,
      { responseType: 'blob', headers }) as Observable<any>;
  }

  printPreview(printObject) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    this.httpClient.put(this.app.getUrl() + environment.printPreviewNspRequestUrl,
      printObject, { responseType: 'blob', headers }).subscribe(data => {
        var file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        printJS(fileURL);
      });
  }

  printFamilyRequestPreview(printObject) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    this.httpClient.put(this.app.getUrl() + environment.printPreviewFamilyRequestUrl,
      printObject, { responseType: 'blob', headers }).subscribe(data => {
        var file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        printJS(fileURL);
      });
  }
}